module.exports = "<!-- ko  -->\n    <!-- ko template: { name: 'survey-content', data: model.survey  } -->\n    <!-- /ko -->\n<!-- /ko -->";